var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFolder = function SvgFolder(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 30.26 25"
  }, props), _g || (_g = React.createElement("g", {
    "data-name": "Layer 2"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M28.4 3.25H15.13L11.88 0h-10A1.86 1.86 0 000 1.86v21.28A1.86 1.86 0 001.86 25H28.4a1.86 1.86 0 001.86-1.86v-18a1.86 1.86 0 00-1.86-1.89z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M24.83 19.62H6.17v-1.5h17.16v-7.49h1.5v8.99z"
  }))));
};
export default __webpack_public_path__ + "2782038158d60a45efb55c24e7048f1f.svg";
export { SvgFolder as ReactComponent };